import {OrderStates, useClient, useDictionary, useOrders} from '@adamlip/okeoke.client';
import {Button, Divider, Listbox, ListboxItem} from '@nextui-org/react';
import SubmittedOrderHeaderV2 from 'components/SubmittedOrder/SubmittedOrderHeaderV2';
import {useNavigate} from 'react-router-dom';

function OpenOrderList() {
  const navigate = useNavigate();
  const {getValue} = useDictionary();
  const {orders} = useOrders();
  const {locations} = useClient();
  const handleClickOnOrder = (order) => {
    let orderLocationData = Object?.values(locations || {})?.find((loc) => loc?.uuid === order?.locationUUID);
    if (order.orderState > OrderStates.UNCONFIRMED) {
      navigate(`/orderview/${order.uuid}`);
    }
    if (order.orderState <= OrderStates.UNCONFIRMED) {
      if (order.paymentType === 'offline' || (order.paymentType === 'Offline' && orderLocationData?.useExternalOrderManager === 1)) {
        navigate(`/offlinebackref/${order.uuid}`);
        return;
      }
      if (order.paymentState?.paymentUrl != null) {
        window.location.href = order.paymentState?.paymentUrl;
      }
      if (order.paymentState?.paymentUrl == null && order.paymentState?.paymentInProgress === false) navigate(`/orderpay/select/${order.uuid}`);
    }
  };
  if (typeof orders !== 'object')
    return (
      <div className='orderHistory-root'>
        <h2>{getValue('app_v2_orderHistory_noOpenOrders')}</h2>
      </div>
    );

  return (
    <div className='w-full flex flex-col gap-2 h-full'>
      {Object.values(orders || {})?.filter((order) => order?.orderState < 90)?.length === 0 ? (
        <div className='orderHistory-root mb-11 flex flex-col items-center justify-center w-full'>
          <h2 className='font-bold text-lg mb-4'>{getValue('app_v2_orderHistory_noOpenOrders')}</h2>
          <Button
            color='primary'
            fullWidth
            className={` my-2  !rounded-[var(--general-border-radius)] `}
            onClick={() => {
              navigate(`/order`);
            }}>
            {getValue('app_v2_order')}
          </Button>
        </div>
      ) : (
        <Listbox aria-label='Actions' classNames={{}}>
          {Object.values(orders || {})
            ?.filter((order) => order?.orderState < 90)
            ?.map((order) => {
              //  <div
              //    className='orderHistory-order'
              //    key={order.uuid}
              //    onClick={() => {
              //      handleClickOnOrder(order);
              //    }}>
              //    <SubmittedOrderHeaderV2 order={order} />
              //  </div>;
              return (
                <ListboxItem aria-label='123' key={order?.uuid} onClick={() => handleClickOnOrder(order)}>
                  <SubmittedOrderHeaderV2 order={order} />
                  <Divider className='mt-2 bg-[var(--main-border-color)]' />
                </ListboxItem>
              );
            })}
        </Listbox>
      )}
    </div>
  );
}

export default OpenOrderList;
